import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Button, Dialog, Grid } from '@mui/material';
import PopupTitle from '../common/popup_title';

const DeleteAccountDisallowedBeforeExpirationPopup = ({
  expirationDate,
  onDismiss,
}) => {
  return (
    <Dialog
      open
      // size="md"
      PaperProps={{
        style: {
          width: '250px',
          height: '240px',
          padding: '10px',
        },
      }}
      anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
      onClose={onDismiss}>
      <Grid container>
        <Grid item xs={12}>
          <PopupTitle
            closeButtonEnabled
            onClickClose={onDismiss}
            titleText="Delete account"
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          You have an active subscription until{' '}
          {dayjs(expirationDate).format('DD MMM YYYY')}. You can only delete
          your account after that date, and your subscription is cancelled.
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          {/* <Box display="flex" justifyContent="flex-end"> */}
          <Button
            onClick={(ev) => {
              onDismiss();
              ev.stopPropagation();
            }}
            variant="contained"
            color="primary"
            size="medium"
            fullWidth
            // style={{ justifyContent: 'flex-end' }}
            disableElevation>
            OK
          </Button>
          {/* </Box> */}
        </Grid>
      </Grid>
    </Dialog>
  );
};

DeleteAccountDisallowedBeforeExpirationPopup.propTypes = {
  expirationDate: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default DeleteAccountDisallowedBeforeExpirationPopup;
